<template>
	<section ref="sectionRef"
			 class="flex-module container-fluid flexible-parallax-image-text">
		<div class="row"
			 :class="{ 'reverse': item.image_position === 'left' }">
			<div ref="textWrapperRef"
				 class="col-xs-12 col-md-4 text-content"
				 :class="{ 'col-md-offset-2': item.image_position === 'left' }">
				<h3 ref="titleRef"
					class="image-title"
					:class="{ 'so-move': !isMobile }">
					{{ item.title }}
				</h3>
				<div ref="textRef"
					 class="image-text"
					 :class="{ 'so-move': !isMobile }">
					<baseRichText :data="item.body" />
				</div>
			</div>
			<div ref="imgWrapperRef"
				 class="col-xs-12 col-md-6 image-wrapper"
				 :class="{ 'col-md-offset-2': item.image_position === 'right' }">

				<basePicture v-if="item.image"
							 :image="item.image"
							 sizes="xs:100vw md:50vw lg:50vw xl:50vw 2xl:50vw 3xl:50vw"
							 class="so-paraimg"
							 loading="eager" />
			</div>
		</div>
	</section>
</template>

<script setup>
const props = defineProps({
	data: {
		type: Object,
		required: true
	}
})

const { gsap } = useGsap()
const mediaQuery = gsap.matchMedia()
const isMobile = useBreakpoint('below', 'md')

const sectionRef = ref(null)
const textWrapperRef = ref(null)
const titleRef = ref(null)
const textRef = ref(null)
const imgWrapperRef = ref(null)

const triggers = {}

const item = computed(() => props?.data?.item)

function moveText() {
	mediaQuery.add('(min-width: 768px)', () => {
		const textWrapper = textWrapperRef.value
		const textWrapperHeight = textWrapper.clientHeight
		const imgWrapper = imgWrapperRef.value
		const imgWrapperHeight = imgWrapper.clientHeight
		const title = titleRef.value
		const text = textRef.value

		// if (textWrapperHeight < imgWrapperHeight) {
		// gsap.set(textWrapper, { height: textWrapperHeight * 1.5 })
		// }

		triggers.tl = gsap.timeline({
			scrollTrigger: {
				trigger: textWrapper,
				start: 'top bottom',
				end: 'bottom center',
				scrub: true,
			}
		})

		triggers.tl
			.fromTo(title, { y: 0 }, { y: (textWrapperHeight / 100 * 20).toFixed(2) })
			.fromTo(text, { y: textWrapperHeight.toFixed(2) }, { y: ((textWrapperHeight / 100 * 20)).toFixed(2) }, 0)

		return () => {
			// custom cleanup code
		}
	})
}

function initAnims() {
	moveText()
}

onMounted(() => {
	useAnims(initAnims, triggers)
})
</script>

<style lang="scss" scoped>
.flexible-parallax-image-text {
	overflow: visible;
}

.image-wrapper {
	position: relative;
	overflow: hidden;

	:deep(picture) {
		display: block;
		position: relative;
		height: 100%;
		width: 100%;
		// bottom: 0;
		margin: 0 auto;
		@include rounded-corners;

		img {
			height: 140%;
			width: 100%;
			object-fit: cover;
			object-position: center;
		}
	}
}

.text-content {
	@include textH5;
	position: relative;
	margin-bottom: 1em;

	.image-title {
		position: relative;
		text-align: left;
		margin: 0;
		@include textH5;

		@include for-devices-below(md) {
			position: relative;
			top: unset;
			transform: unset;
			padding-top: 0;
		}
	}

	.image-text {
		position: absolute;

		.richtext {
			@include textH5;
			text-align: left;
			margin: 0;
			font-weight: normal;
			line-height: 1.2
		}

		@include for-devices-below(md) {
			position: relative;
			top: unset;
			transform: unset;
			padding-top: 0;
		}
	}
}
</style>